import React from 'react';
import {
  Image,
  StyleSheet,
  TouchableHighlight,
  View,
} from '../base_components';

const styles = StyleSheet.create({
  imageButton: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  inner: {
    flex: 1,
    alignSelf: 'stretch',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
  },
  icon: {
    width: '100%',
    height: '100%',
  },
});

type Props = {
  style: any;
  source: any;
  url?: string;
  underlayColor?: string;
  resizeMode?: string;
  onPress?: () => void;
};

export default class ImageButton extends React.PureComponent<Props> {
  render() {
    const { style, source, underlayColor, resizeMode, onPress } = this.props;

    return (
      <TouchableHighlight
        style={[styles.imageButton, style]}
        underlayColor={underlayColor || 'rgba(255,255,255,0.2)'}
        onPress={onPress}
      >
        <View style={styles.inner}>
          <Image
            style={styles.icon}
            resizeMode={resizeMode || 'contain'}
            source={source}
          />
        </View>
      </TouchableHighlight>
    );
  }
}
